<p-messages [(value)]="msgs"></p-messages>
<div class="p-grid">
    <div class="col-12 p-md-12 p-lg-12" *ngIf="cargandoDataInit">
        <div class="card">
            <h4>{{appConfig.ux.loadingMsg}}</h4>
            <p-progressBar mode="indeterminate"></p-progressBar> 
        </div>
    </div>
    <div class="col-12 p-md-12 p-lg-12" *ngIf="!cargandoDataInit">
        <div class="card">
            <p-table #dt [value]="usuarios" [columns]="cols" dataKey="id"
                     selectionMode="multiple" [(selection)]="usuariosSeleccionados"
                     [rowHover]="true" [rows]="10" [paginator]="true"
                     [scrollable]="false" [responsive]='true'
                     [filterDelay]="0" [globalFilterFields]="['codigo','nombre','username','email']"
                     sortMode="multiple" [multiSortMeta]="multiSortMeta"
                     [showCurrentPageReport]="true" currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} entradas"
                     styleClass="p-datatable-striped">
                <ng-template pTemplate="caption">
                    <div class="p-d-flex p-flex-column p-flex-md-row p-jc-md-between table-header">
                        <button pButton type="button" 
                                label="{{appConfig.ux.actions.create}}" 
                                icon="pi pi-plus"
                                (click)="nuevoUsuario();"
                                [disabled]="!puedeEjecutar('crear')">
                        </button>
                        <span class="p-input-icon-left">
                            <i class="pi pi-search"></i>
                            <input pInputText type="text" (input)="dt.filterGlobal($event.target.value, 'contains')"
                                   placeholder="Buscar.."/>
                        </span>
                    </div>
                </ng-template>
                <ng-template pTemplate="header" let-columns>
                    <tr>
                        <!--                        <th style="width: 3rem">
                                            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
                                            </th>-->
                        <th *ngFor="let col of columns" [pSortableColumn]="col.field" [hidden]="!col.visible">
                            <div class="p-d-flex p-jc-between p-ai-center">
                                {{col.header}}
                                <p-sortIcon [field]="col.field"></p-sortIcon>
                            </div>
                        </th>
                        <th style="width: 12rem"></th>
                    </tr>
                </ng-template>
                <ng-template pTemplate="body" let-rowData let-columns="columns"r>
                    <tr>
                        <!--                        <td style="width: 3rem">
                                            <p-tableCheckbox [value]="rowData"></p-tableCheckbox>
                                            </td>-->
                        <td *ngFor="let col of columns" [hidden]="!col.visible">
                            {{rowData[col.field]}}
                        </td>
                        <td style="width: 12rem">
                            <button pButton type="button" 
                                    pTooltip="{{appConfig.ux.actions.config}}" tooltipPosition="bottom" 
                                    icon="pi pi-cog" class="p-button-rounded"
                                    (click)="pl.resetFilter(); editarUsuarioPrivilegios(rowData)"
                                    [disabled]="!puedeEjecutar('escritura')">
                            </button>
                            <button pButton type="button" 
                                    pTooltip="{{appConfig.ux.actions.edit}}" tooltipPosition="bottom" 
                                    icon="pi pi-pencil" class="p-button-rounded p-button-text p-button-plain"
                                    (click)="editarUsuario(rowData);"
                                    [disabled]="!puedeEjecutar('escritura')">
                            </button>
                            <button *ngIf="rowData['username'] 
                                    && (!rowData['username'].toLowerCase().includes('admin')
                                    && !rowData['username'].toLowerCase().includes('usuario'))"
                                    pButton type="button" 
                                    pTooltip="{{appConfig.ux.actions.delete}}" tooltipPosition="bottom" 
                                    icon="pi pi-trash" class="p-button-rounded p-button-text p-button-secondary"
                                    (click)="confirmarBorrarUsuario(rowData);"
                                    [disabled]="!puedeEjecutar('borrado')">
                            </button>
                        </td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="emptymessage">
                    <tr>
                        <td colspan="8">{{appConfig.ux.emptyMsg}}</td>
                    </tr>
                </ng-template>
                <ng-template pTemplate="summary">
                    <button pButton type="button" 
                            pTooltip="{{appConfig.ux.actions.refresh}}" tooltipPosition="bottom" 
                            icon="pi pi-refresh" class="p-button-rounded p-button-text"
                            (click)="dt.reset();">
                    </button>
                </ng-template>
            </p-table>
        </div>
    </div>
</div>
<!--------------------------------------->
<!------Diálogos de funcionalidades------>
<!--------------------------------------->
<p-dialog [header]="(usuario && usuario.id) ? 'Editar Usuario' : 'Nuevo Usuario'" 
          [(visible)]="mostrarEditor" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
          (onHide)="mostrarEditor=false;">
    <form #usuarioEditorForm="ngForm"
          (ngSubmit)="guardarUsuario();"
          [ngClass]="{'disabledForm': false}"><!-- usuarioEditorForm.reset();-->
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12">
                <h2 class="p-text-uppercase">{{usuario.name}}</h2>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="codigo">Cédula de Identidad</label>
                <input #codigo="ngModel" id="codigo" name="codigo" type="text" 
                       [(ngModel)]="usuarioCodigo"
                       (blur)="verificarUsuarioExistente($event)" 
                       [pattern]="appConfig['validationRegExp']['cedulaPattern']"
                       [disabled]="(usuario && usuario.id)"
                       minlength="10" maxlength="10"
                       required pInputText>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="nombre">Nombre</label>
                <input #nombre="ngModel" id="nombre" name="nombre" type="text" 
                       [(ngModel)]="usuario.name"
                       [pattern]="appConfig['validationRegExp']['safeTextPattern']"
                       [disabled]="usuario.username 
                       && (usuario.username.toLowerCase().includes('admin')
                       || usuario.username.toLowerCase().includes('usuario'))"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeTextPattern']" 
                           *ngIf="usuarioEditorForm.controls['nombre']
                           && !usuarioEditorForm.controls['nombre'].valid 
                           && (usuarioEditorForm.controls['nombre'].dirty 
                           || usuarioEditorForm.controls['nombre'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="email">Correo electrónico</label>
                <input #email="ngModel" id="email" name="email" type="text" 
                       [(ngModel)]="usuario.email"
                       [pattern]="appConfig['validationRegExp']['emailPattern']"
                       required pInputText>
                <p-message severity="error" [text]="appConfig['validationMsgs']['emailPattern']" 
                           *ngIf="usuarioEditorForm.controls['email']
                           && !usuarioEditorForm.controls['email'].valid 
                           && (usuarioEditorForm.controls['email'].dirty 
                           || usuarioEditorForm.controls['email'].touched)">
                </p-message>
            </div>
            <div class="p-field col-12 p-md-6">
                <label for="contrasenia">Contraseña</label>
                <p-password #contrasenia="ngModel" id="contrasenia" name="contrasenia" 
                            [(ngModel)]="usuario.contrasenia"
                            ngDefaultControl="true" [toggleMask]="true"
                            mode="advanced" promptLabel="Débil"
                            weakLabel="Débil" mediumLabel="Media" strongLabel="Fuerte"
                            [feedback]="true"
                            strongRegex="^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})"
                            [required]="(!usuario || !usuario.id)">
                    <ng-template pTemplate="header">
                        <h6>Escoge una contraseña</h6>
                    </ng-template>
                    <ng-template pTemplate="footer">
                        <p-divider></p-divider>
                        <p class="p-mt-2">Sugerencias</p>
                        <ul class="p-pl-2 p-ml-2 p-mt-0" style="line-height: 1.5">
                            <li>Al menos una minúscula</li>
                            <li>Al menos una mayúscula</li>
                            <li>Al menos una numérica</li>
                            <li>Un mínimo de 8 caracteres</li>
                        </ul>
                    </ng-template>
                </p-password>
            </div>
            <div class="p-field col-12">
                <label for="descripcion">Descripción</label>
                <textarea #descripcion="ngModel" id="descripcion" name="descripcion" type="text"
                          [(ngModel)]="usuario.description" 
                          [pattern]="appConfig['validationRegExp']['safeMultilineTextPattern']"
                          [rows]="3"
                          pInputTextarea></textarea>
                <p-message severity="error" [text]="appConfig['validationMsgs']['safeMultilineTextPattern']" 
                           *ngIf="usuarioEditorForm.controls['descripcion'] 
                           && !usuarioEditorForm.controls['descripcion'].valid 
                           && (usuarioEditorForm.controls['descripcion'].dirty 
                           || usuarioEditorForm.controls['descripcion'].touched)">
                </p-message>
            </div>
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="mostrarEditor=false;">
                </button>
                <button pButton type="submit" 
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        [disabled]="(!usuarioEditorForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!--Diálogo de asignación de perfiles-->
<p-dialog header=" " 
          [(visible)]="mostrarEditorPrivilegios" 
          modal="modal" showEffect="fade" 
          [breakpoints]="{'960px': '75vw', '640px': '100vw'}" [style]="{width: '75vw'}"
          (onHide)="mostrarEditorPrivilegios=false;">
    <form #usuarioPrivilegiosEditorForm="ngForm"
          (ngSubmit)="confirmarGuardarUsuarioPrivilegios();"
          [ngClass]="{'disabledForm': false}"><!--usuarioPrivilegiosEditorForm.reset();-->
        <p-messages [(value)]="msgs"></p-messages>
        <div class="p-fluid p-formgrid p-grid">
            <div class="p-field col-12 p-text-center">
                <h2 class="p-text-uppercase">Agregar/Quitar Perfiles de {{usuario.name}}</h2>
            </div>
            <div class="p-field col-12">
                <p-pickList #pl [source]="perfilesNoAsignados" [target]="perfilesAsignados"
                            sourceHeader="No asignados" targetHeader="Asignados"
                            filterBy="nombre"
                            [responsive]="true" [dragdrop]="true"
                            [sourceStyle]="{'height':'300px'}" [targetStyle]="{'height':'300px'}">
                    <ng-template let-perfil pTemplate="item">
                        <div> {{perfil.name}} </div>
                    </ng-template>
                </p-pickList>
            </div>
        </div>
        <p-footer>
            <div class="p-d-flex p-flex-lg-row p-flex-column p-jc-end p-mr-lg-3">
                <button pButton type="button" 
                        label="{{appConfig.ux.actions.cancel}}"
                        icon="pi pi-times" class="p-button-secondary"
                        (click)="mostrarEditorPrivilegios=false;">
                </button>
                <button pButton type="submit" 
                        label="{{appConfig.ux.actions.save}}"
                        icon="pi pi-check" class="p-ml-lg-1"
                        [disabled]="(!usuarioPrivilegiosEditorForm.valid)">
                </button>
            </div>
        </p-footer>
    </form>
</p-dialog>
<!---------------------------------------------->
<!------Ventanas de confirmaciones modales------>
<!---------------------------------------------->
<p-confirmDialog #cd header="Confirmación" icon="pi pi-exclamation-triangle">
    <ng-template pTemplate="footer">
        <button pButton type="button" 
                label="No"
                icon="pi pi-times" class="p-button-secondary"
                (click)="cd.reject()">
        </button>
        <button pButton type="button" 
                label="Sí"
                icon="pi pi-check" class="p-ml-2"
                (click)="cd.accept()">
        </button>
    </ng-template>
</p-confirmDialog>